import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const CatalogItemSearch = () => {
  return (
    <MicroFrontEnd
      name="CatalogItemSearch"
      src={apiConfig.microFrontEnds.CatalogItemSearch}
    />
  )
}

export default CatalogItemSearch
